import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\CheckupController::update
* @see app/Http/Controllers/Admin/CheckupController.php:122
* @route '/admin/ai/checkup/api-key'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/admin/ai/checkup/api-key',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\CheckupController::update
* @see app/Http/Controllers/Admin/CheckupController.php:122
* @route '/admin/ai/checkup/api-key'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\CheckupController::update
* @see app/Http/Controllers/Admin/CheckupController.php:122
* @route '/admin/ai/checkup/api-key'
*/
update.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\CheckupController::update
* @see app/Http/Controllers/Admin/CheckupController.php:122
* @route '/admin/ai/checkup/api-key'
*/
const updateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\CheckupController::update
* @see app/Http/Controllers/Admin/CheckupController.php:122
* @route '/admin/ai/checkup/api-key'
*/
updateForm.put = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\CheckupController::destroy
* @see app/Http/Controllers/Admin/CheckupController.php:134
* @route '/admin/ai/checkup/api-key'
*/
export const destroy = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin/ai/checkup/api-key',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\CheckupController::destroy
* @see app/Http/Controllers/Admin/CheckupController.php:134
* @route '/admin/ai/checkup/api-key'
*/
destroy.url = (options?: RouteQueryOptions) => {
    return destroy.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\CheckupController::destroy
* @see app/Http/Controllers/Admin/CheckupController.php:134
* @route '/admin/ai/checkup/api-key'
*/
destroy.delete = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\CheckupController::destroy
* @see app/Http/Controllers/Admin/CheckupController.php:134
* @route '/admin/ai/checkup/api-key'
*/
const destroyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\CheckupController::destroy
* @see app/Http/Controllers/Admin/CheckupController.php:134
* @route '/admin/ai/checkup/api-key'
*/
destroyForm.delete = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const apiKey = {
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default apiKey